import * as Types from '../../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import { AppointmentWizardBodyFragmentDoc } from '../../AppointmentWizard/__generated__/AppointmentWizardBody.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDayAppointmentsForWeekQueryVariables = Types.Exact<{
  startTime: Types.Scalars['Date']['input'];
  endTime: Types.Scalars['Date']['input'];
}>;


export type GetDayAppointmentsForWeekQuery = { __typename?: 'Query', getAppointmentsForDropoffRange: { __typename?: 'ListAppointmentsResponse', items: Array<{ __typename?: 'Appointment', id: string, expectedDropoffTime: any, estimatedPickupTime?: any | null, requestedOn?: any | null, requestedFrom?: string | null, notes?: string | null, appointmentType?: Types.AppointmentType | null, status: Types.AppointmentStatus, shopLocation?: { __typename?: 'ShopLocation', id: string, name: string } | null, customer?: { __typename?: 'Customer', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email?: string | null, secondaryPhoneNumber?: string | null, companyName?: string | null, createdAt: any } | null, car?: { __typename?: 'Car', createdAt: any, licensePlate?: string | null, vin?: string | null, id: string, make?: string | null, model?: string | null, year?: number | null, colour?: string | null } | null, job?: { __typename?: 'Job', jobMetadata: { __typename?: 'JobMetadata', id: string, jobNumber: number, mechanicShopStatus?: Types.JobMechanicShopStatus | null } } | null, callReport?: { __typename?: 'CallReport', id: string, createdAt: any, endReason?: string | null, recordingURL?: string | null, summary?: string | null } | null }> } };


export const GetDayAppointmentsForWeekDocument = gql`
    query GetDayAppointmentsForWeek($startTime: Date!, $endTime: Date!) {
  getAppointmentsForDropoffRange(startTime: $startTime, endTime: $endTime) {
    items {
      ...AppointmentWizardBody
    }
  }
}
    ${AppointmentWizardBodyFragmentDoc}`;

/**
 * __useGetDayAppointmentsForWeekQuery__
 *
 * To run a query within a React component, call `useGetDayAppointmentsForWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDayAppointmentsForWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDayAppointmentsForWeekQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetDayAppointmentsForWeekQuery(baseOptions: Apollo.QueryHookOptions<GetDayAppointmentsForWeekQuery, GetDayAppointmentsForWeekQueryVariables> & ({ variables: GetDayAppointmentsForWeekQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDayAppointmentsForWeekQuery, GetDayAppointmentsForWeekQueryVariables>(GetDayAppointmentsForWeekDocument, options);
      }
export function useGetDayAppointmentsForWeekLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDayAppointmentsForWeekQuery, GetDayAppointmentsForWeekQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDayAppointmentsForWeekQuery, GetDayAppointmentsForWeekQueryVariables>(GetDayAppointmentsForWeekDocument, options);
        }
export function useGetDayAppointmentsForWeekSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDayAppointmentsForWeekQuery, GetDayAppointmentsForWeekQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDayAppointmentsForWeekQuery, GetDayAppointmentsForWeekQueryVariables>(GetDayAppointmentsForWeekDocument, options);
        }
export type GetDayAppointmentsForWeekQueryHookResult = ReturnType<typeof useGetDayAppointmentsForWeekQuery>;
export type GetDayAppointmentsForWeekLazyQueryHookResult = ReturnType<typeof useGetDayAppointmentsForWeekLazyQuery>;
export type GetDayAppointmentsForWeekSuspenseQueryHookResult = ReturnType<typeof useGetDayAppointmentsForWeekSuspenseQuery>;
export type GetDayAppointmentsForWeekQueryResult = Apollo.QueryResult<GetDayAppointmentsForWeekQuery, GetDayAppointmentsForWeekQueryVariables>;